import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase/config';

type QueuedTemplateKey =
  | 'leave_request_created'
  | 'leave_request_approved'
  | 'leave_request_rejected'
  | 'schedule_published'
  | 'register_welcome';

type EnqueueQueuedEmailParams = {
  type: QueuedTemplateKey;
  unitId: string | null;
  payload: Record<string, any>;
};

export type EnqueueQueuedEmailResult = {
  ok: boolean;
  skipped?: boolean;
  reason?: string;
};

export const enqueueQueuedEmail = async (
  type: QueuedTemplateKey,
  unitId: string | null,
  payload: Record<string, any>
): Promise<EnqueueQueuedEmailResult> => {
  const callable = httpsCallable<EnqueueQueuedEmailParams, EnqueueQueuedEmailResult>(
    functions,
    'enqueueQueuedEmail'
  );
  const result = await callable({ type, unitId, payload });
  return result.data;
};
